<template>
  <div class="information-area">
    <h2 class="title text-gray-800 font-semibold text-xl">{{ title }}</h2>
    <div class="content mt-2">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title"]
};
</script>

<style lang="scss" scoped></style>
